<!-- 个人中心 -->
<template>
	<div class="wrap">

		<div class="top">
			<router-link :to="{path: '/'}" style="color: #111111">首页</router-link>
			<span v-if="$route.path == '/my'" class="top-name">
				<img src="../../assets/icon-7.png" class="top-icon">
				个人中心
			</span>
			<router-link v-else :to="{path: '/my'}" style="color: #111111">
				<img src="../../assets/icon-7.png" class="top-icon">
				个人中心
			</router-link>
			<span class="top-name" v-if="$route.path.indexOf('/my/') >= 0">
				<img src="../../assets/icon-7.png" class="top-icon">
				{{$route.meta.title}}
			</span>
		</div>

		<div class="container">

			<div class="leftsidebar">
				<a
					href="javascript:void(0)"
					:class="$route.path == item.path ? 'active' : ''"
					@click="menuClick(item)"
					v-for="(item, index) in menuList"
					:key="index"
				>
					{{item.title}}
					<img v-if="item.title == '设置'" src="../../assets/sanjiao.png" class="sanjiao">
				</a>
			</div>

			<div class="rightsidebar">
				<router-view></router-view>
			</div>

		</div>

		<!-- 签到弹窗 -->
		<div v-show="isSignIn">
			<div class="mask-layer" @click="isSignIn = false"></div>
			<div class="sign-in-window">

				<button type="button" class="sign-in-close-btn" @click="isSignIn = false">
					<img src="../../assets/close-2.png">
				</button>

				<div class="sign-in-window-bg">
					<div class="sign-in-window-label">签到奖励</div>
					<div class="head">
						<img :src="info.headimg" class="avatar" />
						<div class="head-sidebar">
							<div class="head-column">
								<div class="user-name">
									{{info.name}}
								</div>
								<div class="tag">
									<img src="../../assets/bg-10.png" class="tag-bg" />
									<div class="tag-container">
										<img src="../../assets/icon-3.png" class="grade-img" />
										{{info.level_name}}
									</div>
								</div>
							</div>
							<div class="right-tag">
								<img src="../../assets/icon-35.png" />
								<span>{{info.wallet.integral}}</span>积分
							</div>
						</div>
					</div>
				</div>

				<div class="sign-in-window-box">
					<div class="sign-in-module">
						<div class="date-box">
							<div class="big-num">
								{{toDay.d}}
							</div>
							<div class="date-column">
								<div class="week-name">{{toDay.w}}</div>
								<div class="date-msg">{{toDay.m}}{{toDay.y}}</div>
							</div>
						</div>

						<div class="bar">
							<div class="steps">
								<div class="steps-li" v-for="(item, index) in 7" :key="index">
									<div class="step-content" :class="{active: item <= signInfo.sign_num % 7}">
										<div class="sub_title">{{item}}天</div>
										<div class="step-num">
											<img v-if="item == 7" src="../../assets/icon-36.png" class="repair" />
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="sign-in-window-btn-box">
							<button v-if="!isSign" type="default" @click="userSign()">立即签到</button>
							<button v-else type="default" class="gray-bg">立即签到</button>
						</div>
						<div class="sign-in-msg">
							连续签到7天可以获得一张补签卡
						</div>
					</div>

					<div class="sign-in-rules">
						<div class="sign-in-rules-label">签到规则：</div>
						<div class="sign-in-rules-msg" v-html="sysConfig.sign_rule"></div>
					</div>

					<div class="supplementary-signature">
						<div class="supplementary-signature-sidebar">
							<img src="../../assets/icon-36.png" />
							<span>补签卡{{signInfo.sign_card}}张</span>
						</div>
						<button type="default" class="small-btn" @click="retroactive()">去补签</button>
					</div>

				</div>
			</div>
		</div>

		<!-- 签到奖励弹窗 -->
		<div v-show="isSignInAward">
			<div class="mask-layer2" @click="isSignInAward = false"></div>
			<div class="sign-in-award">
				<div class="sign-in-window2">
					<img src="../../assets/bg-23.png" class="window-bg">
					<div class="window-container">
						<div class="window-title">
							<img src="../../assets/left-icon.png">
							获得<span>{{signResult.integral}}</span>积分
							<img src="../../assets/right-icon.png">
						</div>
						<span class="sign-in-row">明天签到可得<span>{{signResult.next_integral}}</span>积分</span>
						<button type="button" class="window-btn" @click="isSignInAward = false">知道了</button>
					</div>
				</div>
				<button type="button" class="close-btn">
					<img src="../../assets/close-icon.png">
				</button>
			</div>
		</div>

		<!-- 补签卡弹窗 -->
		<div v-show="isMakeUpCard">
			<div class="mask-layer2" @click="isMakeUpCard = false"></div>
			<div class="sign-in-award">
				<div class="sign-in-window2">
					<img src="../../assets/bg-23.png" class="window-bg">
					<div class="window-container">
						<img src="../../assets/icon-37.png" class="window-icon">
						<span class="window-msg">恭喜您连续签到七天</span>
						<span class="window-msg">获得1张补签卡</span>
						<button type="button" class="window-btn">签到成功</button>
					</div>
				</div>
				<button type="button" class="close-btn" @click="isMakeUpCard = false">>
					<img src="../../assets/close-icon.png">
				</button>
			</div>
		</div>

	</div>
</template>

<script>
	import dayjs from 'dayjs';
	import { numToChinese } from '../../utils/util';
	import { signCheckSign, signGetContinuousSign, signGetSignCard, signRetroactive, signUserSign, userCenterGetUserInfo } from '../../service/service';
	export default {
		components: {
		},
		data() {
			return {
				menuList: [
					{ title: '我的订单', path: '/my/my-order' },
					{ title: '我的购物车', path: '/shopping-cart' },
					{ title: '浏览记录', path: '/my/browsing-history' },
					{ title: '我的收藏', path: '/my/my-collection' },
					// { title: '我的积分', path: '/my/my-points' },
					{ title: '我的会员', path: '/my/my-member' },
					{ title: '卡券', path: '/my/card-voucher' },
					{ title: '消息', path: '/my/message' },
					{ title: '携手合伙人', path: '/my/partner' },
					{
						title: '签到奖励',
						click: () => {
							// 显示 签到 弹窗
							this.isSignIn = true;
							const day = dayjs();
							this.toDay = {
								y: day.format('YYYY'),
								m: numToChinese(day.month() + 1) + '月',
								d: day.format('DD'),
								w: day.day() == 0 ? '周日' : '周' + numToChinese(day.day()),
							};
							this.sysConfig = JSON.parse(localStorage.getItem('sysConfig') || '{}');
							this.checkSign();
							this.getContinuousSign();
						},
						path: '',
					},
					{ title: '我的分销', path: '/my/my-distribution' },
					// { title: '产品溯源', path: '/my/product-traceability' },
					// { title: '我的预约', path: '/my/my-appointment' },
					{ title: '意见反馈', path: '/my/feedback' },
					{ title: '资讯素材', path: '/my/information-material' },
					// { title: '在线客服', path: '' },
					{
						title: '设置',
						path: '/my/set-up',
					},
				],
				// 用户信息
				info: {
					wallet: {},
				},
				isLogin: true,

				// 签到弹窗
				isSignIn: false,
				// 签到成功弹窗
				isSignInAward: false,
				// 补签卡弹窗
				isMakeUpCard: false,
				// 当期日期
				toDay: {
					y: '',
					m: '',
					d: '',
					w: '',
				},
				isSign: false, // 是否签到 true 是 false 否
				signInfo: {
					is_sign: 0,  // 当天是否签到（0签到，1已签到）
					sign_num: 0,  // 连续签到天数
					sign_card: 0,  // 补签卡数量
				},
				signResult: {
					sign_crystal: '',  // 明信片
					integral: 0,  // 签到获得积分数
					sign_num: 0,  // 连续签到天数
				},

				// 系统文案
				sysConfig: {
					sign_rule: '',
				},
			};
		},
		mounted() {
			this.getUserInfo();
		},
		onShow() {
		},
		methods: {
			// 获取用户信息
			getUserInfo() {
				userCenterGetUserInfo().then(({code, data, msg}) => {
					if (code == 1) {
						localStorage.setItem('USER_INFO', JSON.stringify(data.detail));
						this.info = data.detail;
						this.isLogin = true;
					} else {
						this.$message.error(msg);
					}
				});
			},

			// 判断今天是否签到
			checkSign() {
				signCheckSign().then(({code, data, msg}) => {
					if (code == 1) {
						this.isSign = data.is_sign == 1;
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 获取签到天数
			getContinuousSign() {
				signGetContinuousSign().then(({code, data, msg}) => {
					if (code == 1) {
						this.signInfo = data;
					} else {
						this.$message.error(msg);
					}
				});
			},

			// 签到
			userSign() {
				signUserSign().then(({code, data, msg}) => {
					if (code == 1) {
						this.signResult = data;
						if (data.sign_num % 7 == 0) {
							this.getSignCard();
						} else {
							this.isSignInAward = true;
						}
						this.getUserInfo();
						this.checkSign();
						this.getContinuousSign();
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 获取补签卡
			getSignCard() {
				signGetSignCard().then(({code, msg}) => {
					if (code == 1) {
						this.signGetContinuousSign();
						this.isMakeUpCard = true;
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 补签
			retroactive() {
				if (this.signInfo.sign_card == 0) {
					return this.$message.info('您还没有补签卡');
				}
				
				this.$confirm('确定试用补签卡补签?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					signRetroactive().then(({code, data, msg}) => {
						if (code == 1) {
							if (data.sign_num % 7 == 0) {
								this.getSignCard();
							} else {
								this.isSignInAward = true;
							}
							this.getUserInfo();
							this.checkSign();
							this.getContinuousSign();
						} else {
							this.$message.error(msg);
						}
					});
				});
			},



			// 左侧菜单选择
			menuClick({click, path = ''}) {
				// 如果自定义了点击事件，则只运行自定义点击事件
				if (click) {
					return click();
				} else if (path.length > 0) {
					this.$router.push(path);
				}
			},
			//选项卡
			active(index) {
				this.active = index;
			},
			//我的粉丝
			myFans() {
				this.$router.push('/my/my-fans')
			},
			//我的佣金
			myCommission() {
				this.$router.push('/my/my-commission')
			},
			//首页
			goIndex(){
				this.$router.push('/index')
			}
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		margin: 40px 0 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.top {
		width: 1200px;
		height: 76px;
		line-height: 76px;
		background-color: #FFFFFF;
		border-radius: 8px;
		display: flex;
		align-items: center;
		padding: 0 19px;
		box-sizing: border-box;
		color: #484848;
		font-size: 20px;
		margin: 20px 0;
	}

	.top-icon {
		width: 10px;
		margin: 0 10px;
	}

	.top-name {
		color: #F2501A;
	}

	.container {
		width: 1200px;
		display: flex;
		align-items: flex-start;
		margin-bottom: 43px;
	}

	.leftsidebar {
		width: 144px;
		padding: 21px 0 28px;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 8px;
		margin-right: 19px;
	}

	.leftsidebar>a {
		width: 100%;
		height: 45px;
		line-height: 40px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 0 0 29px;
		box-sizing: border-box;
		color: #000000;
		font-size: 16px;
		position: relative;
	}

	.leftsidebar>a.active {
		color: #F2501A;
		font-size: 18px;
	}

	.leftsidebar>a.active::after {
		content: "";
		position: absolute;
		left: 0;
		top: 50%;
		transform: translate(0, -50%);
		width: 4px;
		height: 26px;
		background: url(../../assets/border.png) no-repeat;
		background-size: 100% 100%;
	}

	.sanjiao {
		width: 14px;
		margin-left: 10px;
	}

	.rightsidebar {
		width: calc(100% - 163px);
		display: flex;
		flex-direction: column;
	}

	.rightsidebar-top {
		width: 100%;
		height: 95px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: #fff;
		border-radius: 8px;
		padding: 0 24px;
		box-sizing: border-box;
	}

	.personal-information-box {
		height: 95px;
		display: flex;
		align-items: center;
	}

	.personal-avatar {
		width: 56px;
		height: 56px;
		border-radius: 50%;
		margin-right: 12px;
	}

	.personal-information-column {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.personal-name {
		width: 100%;
		color: #202020;
		font-size: 18px;
	}

	.personal-tag {
		width: 79px;
		height: 20px;
		line-height: 20px;
		background: url(../../assets/bg-10.png) no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		padding: 0 0 0 8px;
		box-sizing: border-box;
		color: #F2501A;
		font-size: 12px;
		margin-top: 1px;
	}

	.personal-tag>img {
		width: 12px;
		margin-right: 3px;
	}

	.rightsidebar-top-tabList {
		flex: 1;
		display: flex;
		margin-left: 20px;
	}

	.rightsidebar-top-tabList>a {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #F2501A;
		font-size: 16px;
	}

	.tab-list {
		width: 100%;
		height: 70px;
		display: flex;
	}

	.tab-list>li {
		flex: 1;
		height: 70px;
		position: relative;
	}

	.tab-list>li::after {
		content: "";
		width: 1px;
		height: 19px;
		position: absolute;
		right: 0;
		top: 50%;
		transform: translate(0, -50%);
		background-color: #E63D23;
	}

	.tab-list>li:last-child::after {
		background-color: initial;
	}

	.tab-list>li>a {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #000000;
		font-size: 16px;
	}

	.tab-list>li.active>a {
		color: #F2501A;
		font-weight: bold;
	}

	.tab-list>li>a>span {
		color: #F2501A;
		margin-left: 3px;
	}

	.product {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 20px;
	}

	.top-row {
		width: 100%;
		height: 55px;
		background-color: #FFFFFF;
		border-radius: 8px;
		display: flex;
		align-items: center;
		color: #434849;
		font-size: 12px;
		margin-bottom: 10px;
	}

	.top-row>span:first-child {
		width: calc(100% - 666px);
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding-left: 56px;
		box-sizing: border-box;
	}

	.top-row>span {
		width: 111px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.center-module {
		width: 100%;
		background-color: #FFFFFF;
		border-radius: 0 0 8px 8px;
		display: flex;
		flex-direction: column;
		padding: 34px 0;
	}

	.product-module {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 38px;
	}

	.product-module:last-child {
		margin-bottom: 0;
	}

	.sub-item-first {
		width: calc(100% - 666px);
		display: flex;
		align-items: flex-start;
		padding-left: 9px;
		box-sizing: border-box;
	}

	.product-img {
		width: 102px;
		height: 102px;
		border-radius: 6px;
		object-fit: cover;
		margin-right: 11px;
	}

	.product-msg-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.product-name {
		width: 134px;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #000000;
		font-size: 12px;
		margin-bottom: 7px;
	}

	.product-msg {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #666666;
		font-size: 12px;
	}

	.product-msg-red {
		width: 100%;
		color: #F2501A;
		font-size: 12px;
		margin-top: 7px;
	}

	.align-center-box {
		display: flex;
		align-items: center;
		padding-top: 10px;
		box-sizing: border-box;
	}

	.sub-item {
		width: 111px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.tag-row {
		width: 100%;
	}

	.wrap >>>.el-input-number {
		width: 97px !important;
		line-height: 24px !important;
	}

	.el-input-number>>>.el-input::after {
		content: "" !important;
		width: 44px !important;
		height: 24px !important;
		position: absolute !important;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		border-radius: 50px;
		background-color: #EEEEEE !important;
		z-index: 0 !important;
	}

	.wrap >>>.el-input-number__decrease,
	.wrap >>>.el-input-number__increase {

		top: 50% !important;
		transform: translate(0, -50%) !important;
		width: 24px !important;
		height: 24px !important;
		line-height: 24px !important;
		border-radius: 50% !important;
		border: none !important;
		z-index: 99 !important;
		color: #111111 !important;
		background: #EEEEEE !important;
	}

	.el-input-number>>>.el-input__inner {
		height: 24px !important;
		line-height: 24px !important;
		padding-left: 24px !important;
		padding-right: 24px !important;
		background-color: rgba(0, 0, 0, 0) !important;
		z-index: 9 !important;
		color: #111111 !important;
		font-size: 12px !important;
		border: none !important;
		position: relative !important;
	}

	.wrap >>>.el-input-number__decrease,
	.wrap >>>.el-input-number__increase {
		font-size: 10px !important;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.list>li {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 8px;
		margin-bottom: 10px;
	}

	.list-top {
		width: 100%;
		height: 46px;
		display: flex;
		align-items: center;
		padding: 0 9px;
		box-sizing: border-box;
		color: #111111;
		font-size: 14px;
		border-bottom: 1px solid #DCDCDC;
	}

	.list-top>span {
		margin-right: 42px;
	}

	.sub-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 11px 0 17px;
		box-sizing: border-box;
	}

	.sub-list>li {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 27px;
	}

	.sub-list>li:last-child {
		margin-bottom: 0;
	}

	.product-price {
		color: #111111;
		font-size: 12px;
	}

	.product-price-del {
		color: #CACACA;
		font-size: 12px;
	}

	.font-1 {
		color: #434849;
		font-size: 12px;
	}

	.font-2 {
		color: #111111;
		font-size: 12px;
		font-weight: bold;
	}

	.font-3 {
		color: #111111;
		font-size: 12px;
	}

	.font-4 {
		color: #434849;
		font-size: 12px;
	}

	.sub-item-btn {
		color: #111111;
		font-size: 12px;
		margin-bottom: 6px;
	}

	.sub-item-btn:last-child {
		margin-bottom: 0;
	}

	.sub-item-btn.border {
		border: 1px solid #F2501A;
		border-radius: 8px;
		width: 78px;
		height: 31px;
		line-height: 31px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #F2501A;
		font-size: 12px;
	}

	.wrap >>>.el-dialog {
		width: 772px !important;
		position: fixed !important;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		margin: 0 !important;
		border-radius: 8px !important;
		overflow: hidden !important;
	}

	.wrap >>>.el-dialog__header {
		background-color: #EEEEEE !important;
		padding: 15px 22px !important;
	}

	.el-dialog__headerbtn>>>.el-dialog__close {
		color: #777777 !important;
	}

	.wrap >>>.el-dialog__body {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 15px 28px 21px !important;
		box-sizing: border-box !important;
	}

	.wrap >>>.el-dialog__footer {
		padding: 0 28px 21px !important;
		box-sizing: border-box !important;
	}

	.wrap >>>.el-button {
		width: 116px !important;
		height: 40px !important;
		line-height: 40px !important;
		padding: 0 17px !important;
		border-radius: 8px !important;
		font-size: 13px !important;
		font-weight: normal !important;
		box-sizing: border-box !important;
		color: #777777 !important;
		border: 1px solid #6C6C6C !important;
	}

	.wrap >>>.el-button--primary {
		color: #FFFFFF !important;
		border: none !important;
		background-color: #F2501A !important;
	}

	.prompt-msg {
		width: 680px;
		display: flex;
		color: #777777;
		font-size: 12px;
		padding: 5px 26px;
		box-sizing: border-box;
		border: 1px solid #DCDCDC;
	}

	.select-address-list {
		width: 680px;
		display: flex;
		flex-direction: column;
		padding: 20px 75px;
		box-sizing: border-box;
	}

	.select-address-list>li {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.select-address-list>li:last-child {
		margin-bottom: 0;
	}

	.select-address-sidebar {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.people-name {
		min-width: 75px;
		padding: 0 10px;
		box-sizing: border-box;
		height: 36px;
		line-height: 36px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #484848;
		font-size: 13px;
		position: relative;
		border-radius: 5px;
		overflow: hidden;
	}

	.addrss-box {
		flex: 1;
		display: flex;
		align-items: center;
		margin-left: 16px;
	}

	.addrss-msg {
		color: #484848;
		font-size: 14px;
	}

	.people-phone-num {
		color: #484848;
		font-size: 14px;
		margin-left: 20px;
	}

	.select-address-btn-box {
		display: flex;
		align-items: center;
	}

	.select-address-btn-box>button {
		font-size: 16px;
		color: #777777;
		margin-right: 20px;
	}

	.select-address-btn-box>button:last-child {
		margin-right: 0;
		color: #F2501A;
	}

	.select-address-list>li.active .people-name {
		border: 1px solid #E63D23;
	}

	.select-address-list>li.active .people-name::after {
		content: "";
		width: 25px;
		height: 25px;
		background: url(../../assets/icon-24.png) no-repeat;
		background-size: 100% 100%;
		position: absolute;
		right: 0;
		bottom: 0;
	}

	.select-address-list>li.active .addrss-msg {
		color: #F2501A;
	}

	.select-address-list>li.active .people-phone-num {
		color: #F2501A;
	}

	.open-btn {
		width: 680px;
		color: #F2501A;
		font-size: 16px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 75px;
		box-sizing: border-box;
	}

	.cancel-box>>>.el-dialog__title {
		width: 100% !important;
		display: flex !important;
		justify-content: center !important;
	}

	.cancel-box>>>.el-dialog__header {
		background-color: #FFFFFF !important;
	}

	.cancel-box>>>.el-dialog {
		width: 449px !important;
	}

	.cancel-box>>>.el-dialog__body {
		padding: 0 45px !important;
	}

	.cancel-box>>>.el-dialog__footer {
		width: calc(100% - 90px) !important;
		margin: 0 auto !important;
		padding: 0 0 0 0 !important;
		display: flex !important;
	}

	.cancel-box>>>.el-dialog__footer>>>.el-button {
		width: 50% !important;
		border: 1px solid !important;
		margin: 0 !important;
	}

	.cancel-prompt-msg {
		width: 100%;
		background-color: #F6F6F6;
		padding: 10px 11px;
		box-sizing: border-box;
		color: #202020;
		font-size: 12px;
		margin-bottom: 19px;
	}

	.cancel-prompt-title {
		width: 100%;
		color: #777777;
		font-size: 13px;
		margin-bottom: 28px;
	}

	.choose-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding-bottom: 18px;
	}

	.choose-list>li {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 25px;
	}

	.choose-list>li:last-child {
		margin-bottom: 0;
	}

	.choose-name {
		color: #202020;
		font-size: 13px;
	}

	.circle-img {
		width: 20px;
		height: 20px;
	}

	.cancel-footer {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 8px;
		overflow: hidden;
		margin-bottom: 28px;
	}

	.cancel-footer>>>.el-button {
		width: 100% !important;
		margin: 0 !important;
		border-radius: initial !important;
		background-color: #F28A1A !important;
		color: #fff !important;
		border: none !important;
	}

	.cancel-footer>>>.el-button--primary {
		background-color: #F2501A !important;
	}

	.font-5 {
		color: #F2501A;
		font-size: 12px;
	}

	.sub-item>span {
		margin-bottom: 3px;
	}

	.sub-item>span:last-child {
		margin-bottom: 0;
	}

	.mask-layer {
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.38);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
	}

	.sign-in-window {
		width: 514px;
		min-height: 620px;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: #F2F2F2;
		z-index: 1000;
		border-radius: 13px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.sign-in-window-bg {
		width: 100%;
		height: 198px;
		display: flex;
		flex-direction: column;
		background: linear-gradient(180deg, #F2501A, #FF865D);
	}

	.head {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 0 0 0 25px;
		box-sizing: border-box;
	}

	.avatar {
		width: 55px;
		height: 55px;
		border-radius: 50%;
		border: 2px solid #fff;
		margin-right: 11px;
		box-sizing: border-box;
	}

	.head-sidebar {
		flex: 1;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.user-name {
		width: 100%;
		color: #FFFFFF;
		font-size: 17px;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.tag {
		width: 79px;
		height: 20px;
		position: relative;
	}

	.tag-bg {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 10;
	}

	.tag-container {
		width: 100%;
		height: 100%;
		line-height: 20px;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 100;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FF6D00;
		font-size: 12px;
	}

	.grade-img {
		width: 14px;
		height: 14px;
		margin-right: 1px;
	}

	.head-column {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.right-tag {
		min-width: 116px;
		height: 39px;
		line-height: 39px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 25px 0 0 25px;
		background: rgba(255, 255, 255, 0.33);
		color: #FFFFFF;
		font-size: 14px;
	}

	.right-tag img {
		width: 15px;
		height: 15px;
		margin-right: 6px;
	}

	.right-tag span {
		color: #FFFFFF;
		font-size: 20px;
		margin-right: 4px;
	}

	.sign-in-window-label {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 67px;
		line-height: 67px;
		color: #FFFFFF;
		font-size: 18px;
		margin-bottom: 15px;
	}

	.sign-in-close-btn {
		background-color: initial;
		position: absolute;
		padding: 14px 19px;
		right: 0;
		top: 0;
	}

	.sign-in-close-btn>img {
		width: 13px;
	}

	.sign-in-module {
		width: 100%;
		min-height: 266px;
		background-color: #FFFFFF;
		border-radius: 15px;
		position: relative;
		margin-bottom: 10px;
	}

	.sign-in-img {
		width: 138px;
		height: 126px;
		position: absolute;
		right: 0;
		top: -30px;
	}

	.date-box {
		display: flex;
		align-items: center;
		padding: 16px 20px 0;
	}

	.big-num {
		font-size: 51px;
		color: #000000;
		font-weight: bold;
		margin-right: 9px;
	}

	.date-column {
		display: flex;
		flex-direction: column;
	}

	.week-name {
		color: #000000;
		font-size: 18px;
	}

	.date-msg {
		color: #777777;
		font-size: 14px;
	}

	.sign-in-window-btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 20px 85px;
		box-sizing: border-box;
	}

	.sign-in-window-btn-box button {
		width: 100%;
		height: 45px;
		line-height: 45px;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 17px;
		background: linear-gradient(90deg, #F2501A, #F67346);
	}

	.gray-bg {
		background: #E0E0E0 !important;
		color: #777777 !important;
	}

	.sign-in-msg {
		width: 100%;
		text-align: center;
		color: #777777;
		font-size: 13px;
	}

	.supplementary-signature {
		width: 100%;
		background-color: #fff;
		border-radius: 8px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 22px;
		padding: 8px 12px 8px 18px;
		box-sizing: border-box;
	}

	.small-btn {
		width: 75px;
		height: 30px;
		line-height: 30px;
		border-radius: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 12px;
		background: linear-gradient(90deg, #F2501A, #F67346);
	}

	.supplementary-signature-sidebar {
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #000000;
	}

	.supplementary-signature-sidebar img {
		width: 60px;
		margin-right: 10px;
	}

	.sign-in-rules {
		width: 100%;
		background-color: #fff;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		margin-bottom: 10px;
		padding: 13px 12px;
		box-sizing: border-box;
	}

	.sign-in-rules-label {
		color: #777777;
		font-size: 16px;
		margin-bottom: 5px;
	}

	.sign-in-rules-msg {
		width: 100%;
		color: #777777;
		font-size: 14px;
	}


	.bar {
		margin-top: 25px;
	}

	.steps {
		width: 100%;
		display: flex;
	}

	.steps-li {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;

	}

	.step-content {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
	}

	.step-num {
		height: 5px;
		width: 5px;
		background-color: #A7A7A7;
		border-radius: 50%;
		text-align: center;
		box-sizing: border-box;
		position: relative;
	}

	.steps-li:last-child .step-num {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.steps-li::after {
		content: "";
		width: 60%;
		height: 1px;
		background-color: #A7A7A7;
		position: absolute;
		top: 92%;
		transform: translate(0, -50%);
		left: 70%;
	}

	.steps-li:last-child::after {
		width: 0;
	}

	.sub_title {
		font-size: 14px;
		color: #A7A7A7;
		margin-bottom: 7px;
	}

	.active .step-num {
		background-color: #000000;
	}

	.steps-li.active::after {
		background-color: #6C6C6C;
	}

	.active .sub_title {
		color: #000000;
	}

	.repair {
		width: 35px !important;
		position: absolute;
		left: -10px;
		top: -8px;
	}

	.sign-in-window-box {
		width: calc(100% - 38px);
		margin: -40px auto 0;
	}

	/* 签到奖励弹窗 */
	.mask-layer2 {
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.4);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1001 !important;
	}

	.sign-in-award {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 1002 !important;
	}

	.sign-in-window2 {
		width: 278px;
		height: 280px;
		display: flex;
		flex-direction: column;
		position: relative;
	}

	.window-bg {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 99;
	}

	.window-container {
		width: 100%;
		height: 60%;
		position: absolute;
		left: 0;
		top: 40%;
		z-index: 999;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.close-btn {
		width: 100%;
		background-color: initial;
		border-radius: initial;
		margin-top: 30px;
	}

	.close-btn img {
		width: 34px;
	}

	.window-icon {
		width: 70px;
		margin-bottom: 2.5px;
	}

	.window-msg {
		font-size: 13px;
		color: #31333A;
	}

	.window-btn {
		width: 132px;
		height: 32px;
		line-height: 32px;
		color: #FFFFFF;
		font-size: 16px;
		background-color: #F2501A;
		border-radius: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 9px;
	}

	.sign-in-row {
		width: 100%;
		text-align: center;
		font-size: 13px;
		color: #8C8C8C;
		margin-bottom: 20px;
	}

	.sign-in-row span {
		font-weight: bold;
		margin: 0 5px;
		color: #F2501A;
	}

	.window-title {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #2A2A2A;
		font-size: 36rpx;
		margin: 22.5px 0 7.5px;
	}

	.window-title span {
		font-size: 24px;
		color: #F2501A;
		margin: 0 5px;
	}

	.window-title img {
		width: 18px;
		margin: 0 19px;
	}

	.normal-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #999999;
		font-size: 18px;
		padding: 100px 0;
	}

	.normal-box>img {
		width: 40%;
		margin-bottom: 6px;
	}

	.normal-box>button {
		width: 111px;
		height: 47px;
		line-height: 47px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #F2501A;
		font-size: 20px;
		border: 1px solid #F2501A;
		box-sizing: border-box;
		border-radius: 50px;
		margin-top: 10px;
	}
</style>
